import { action } from "satcheljs";
import type { MailboxInfo } from "owa-client-types";

export interface LEAVE_GROUP_SUCCESSActionMessage {
    groupId: string;
    mailboxInfo: MailboxInfo;
}
export const leaveGroupSuccess: (groupId: string, mailboxInfo: MailboxInfo) => LEAVE_GROUP_SUCCESSActionMessage = action("LEAVE_GROUP_SUCCESS", (groupId: string, mailboxInfo: MailboxInfo): LEAVE_GROUP_SUCCESSActionMessage => ({
    groupId,
    mailboxInfo,
}));
